import { FormizoSchema } from "Components/LabIZO/Formizo/FormizoSchema.interface";

export const InputFieldSetting: FormizoSchema[] = [
  {
    header: "Word Limit",
  },
  {
    label: "TC",
    name: "SettingDoc.config.WordLimit.TC",
    format: "number",
    variant: "outlined",
  },
  {
    label: "SC",
    name: "SettingDoc.config.WordLimit.SC",
    format: "number",
    variant: "outlined",
  },
  {
    label: "EN",
    name: "SettingDoc.config.WordLimit.EN",
    format: "number",
    variant: "outlined",
  },
  {
    label: "Long Question",
    name: "SettingDoc.config.LongQuestion",
    format: "number",
    variant: "outlined",
  },
  {
    header: "Instruction for welcome",
  },
  {
    label: "TC",
    name: "SettingDoc.Message.WelcomeInstruction.TC",
    format: "text",
    variant: "outlined",
  },
  {
    label: "SC",
    name: "SettingDoc.Message.WelcomeInstruction.SC",
    format: "text",
    variant: "outlined",
  },
  {
    label: "EN",
    name: "SettingDoc.Message.WelcomeInstruction.EN",
    format: "text",
    variant: "outlined",
  },
  {
    header: "Instruction for text",
  },
  {
    label: "TC",
    name: "SettingDoc.Message.TextInstruction.TC",
    format: "text",
    variant: "outlined",
  },
  {
    label: "SC",
    name: "SettingDoc.Message.TextInstruction.SC",
    format: "text",
    variant: "outlined",
  },
  {
    label: "EN",
    name: "SettingDoc.Message.TextInstruction.EN",
    format: "text",
    variant: "outlined",
  },
  {
    header: "Instruction for button",
  },
  {
    label: "TC",
    name: "SettingDoc.Message.ButtonInstruction.TC",
    format: "text",
    variant: "outlined",
  },
  {
    label: "SC",
    name: "SettingDoc.Message.ButtonInstruction.SC",
    format: "text",
    variant: "outlined",
  },
  {
    label: "EN",
    name: "SettingDoc.Message.ButtonInstruction.EN",
    format: "text",
    variant: "outlined",
  },
];
